import React from 'react'
import { Link } from 'react-router-dom'

export default function RejectedPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="text-6xl mb-6">✕</div>
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Access Denied</h1>
        <p className="text-gray-600 mb-8 max-w-md">
          Your access request was not approved. Please contact <a href="mailto:support@sitedeck.pro" className="text-blue-600 hover:underline">support@sitedeck.pro</a> for assistance.
        </p>
        <Link to="/login" className="text-blue-600 hover:underline font-medium">Back to Login</Link>
      </div>
    </div>
  )
}